var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-3 card" }, [
    _c("div", { staticClass: "card-header bg-secondary-3" }, [
      _vm.value.area.letter
        ? _c(
            "div",
            {
              staticClass:
                "rounded letter-box mr-2 d-inline-flex align-items-center justify-content-center",
              style: {
                color: _vm.value.area.letterColor || "white",
                backgroundColor:
                  `${_vm.value.area.letterColor}14` || "#2db78226",
                borderColor: _vm.value.area.letterColor || "#2db782"
              }
            },
            [_vm._v(" " + _vm._s(_vm._f("empty")(_vm.value.area.letter)) + " ")]
          )
        : _vm._e(),
      _vm.titlePrefix
        ? _c("span", { staticClass: "mr-2" }, [_vm._v(_vm._s(_vm.titlePrefix))])
        : _vm._e(),
      _c("b", [
        _vm._v(" " + _vm._s(_vm._f("empty")(_vm.value.area.name)) + " "),
        _vm.value.area.description ? _c("span", [_vm._v(":")]) : _vm._e()
      ]),
      _vm.value.area.description
        ? _c("span", [
            _vm._v(
              " " + _vm._s(_vm._f("empty")(_vm.value.area.description)) + " "
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "card-body bg-secondary-3" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12", class: { "col-md": !_vm.isHalf } }, [
          _c("label", { staticClass: "data-name" }, [
            _vm._v(_vm._s(_vm.requiredLevelLabel))
          ]),
          _c("div", { staticClass: "row d-flex align-items-center" }, [
            _c(
              "div",
              {
                staticClass: "col-12",
                class: {
                  "col-md-3": _vm.hasBoolValue(
                    _vm.model.requiredLevel?.hasOther
                  )
                }
              },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _vm.isYesNoOption
                            ? _c("custom-radio", {
                                staticClass: "row",
                                attrs: {
                                  "custom-error-msg": "El campo es requerido.",
                                  disabled: _vm.isReadOnly,
                                  error: !!errors[0],
                                  "is-inline": "",
                                  name: `requiredLevel-${_vm.value.area.id}`,
                                  options: _vm.options
                                },
                                model: {
                                  value: _vm.requiredLevel,
                                  callback: function($$v) {
                                    _vm.requiredLevel = $$v
                                  },
                                  expression: "requiredLevel"
                                }
                              })
                            : _c("custom-drop-down", {
                                attrs: {
                                  clearable: !_vm.isReadOnly,
                                  "custom-error-msg": "El campo es requerido.",
                                  disabled: _vm.isReadOnly,
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  options: _vm.options,
                                  placeholder: "Seleccione"
                                },
                                model: {
                                  value: _vm.requiredLevel,
                                  callback: function($$v) {
                                    _vm.requiredLevel = $$v
                                  },
                                  expression: "requiredLevel"
                                }
                              })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm.hasBoolValue(_vm.model.requiredLevel?.hasOther)
              ? _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _vm.model.requiredLevel.hasOther &&
                                !_vm.isReadOnly
                                  ? _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        error: errors[0],
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.model.requiredLevel.other,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.requiredLevel,
                                            "other",
                                            $$v
                                          )
                                        },
                                        expression: "model.requiredLevel.other"
                                      }
                                    })
                                  : _c("input", {
                                      staticClass: "form-control",
                                      attrs: { disabled: "" },
                                      domProps: {
                                        value: _vm.value.requiredLevel.other
                                      }
                                    })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3634773242
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _vm.isHalf
          ? _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "border-top my-4" })
            ])
          : _vm._e(),
        _c("div", { staticClass: "col-12", class: { "col-md": !_vm.isHalf } }, [
          _c("label", { staticClass: "data-name" }, [
            _vm._v(_vm._s(_vm.evaluatedLevelLabel))
          ]),
          _c("div", { staticClass: "row d-flex align-items-center" }, [
            _c(
              "div",
              {
                staticClass: "col-12",
                class: {
                  "col-md-3": _vm.hasBoolValue(
                    _vm.model.evaluatedLevel?.hasOther
                  )
                }
              },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _vm.isYesNoOption
                            ? _c("custom-radio", {
                                staticClass: "row",
                                attrs: {
                                  "custom-error-msg": "El campo es requerido.",
                                  disabled: _vm.isReadOnly,
                                  error: !!errors[0],
                                  "is-inline": "",
                                  name: `evaluatedLevel-${_vm.value.area.id}`,
                                  options: _vm.options
                                },
                                model: {
                                  value: _vm.evaluatedLevel,
                                  callback: function($$v) {
                                    _vm.evaluatedLevel = $$v
                                  },
                                  expression: "evaluatedLevel"
                                }
                              })
                            : _c("custom-drop-down", {
                                attrs: {
                                  clearable: !_vm.isReadOnly,
                                  "custom-error-msg": "El campo es requerido.",
                                  disabled: _vm.isReadOnly,
                                  error: errors[0],
                                  fieldkey: "id",
                                  fieldname: "name",
                                  options: _vm.options,
                                  placeholder: "Seleccione"
                                },
                                model: {
                                  value: _vm.evaluatedLevel,
                                  callback: function($$v) {
                                    _vm.evaluatedLevel = $$v
                                  },
                                  expression: "evaluatedLevel"
                                }
                              })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm.hasBoolValue(_vm.model.evaluatedLevel?.hasOther)
              ? _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _vm.model.evaluatedLevel.hasOther &&
                                !_vm.isReadOnly
                                  ? _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        error: errors[0],
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.model.evaluatedLevel.other,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model.evaluatedLevel,
                                            "other",
                                            $$v
                                          )
                                        },
                                        expression: "model.evaluatedLevel.other"
                                      }
                                    })
                                  : _c("input", {
                                      staticClass: "form-control",
                                      attrs: { disabled: "" },
                                      domProps: {
                                        value: _vm.value.evaluatedLevel.other
                                      }
                                    })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        500588268
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _vm.isHalf
          ? _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "border-top my-4" })
            ])
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "col-12 d-flex align-items-center",
            class: { "col-md": !_vm.isHalf }
          },
          [
            _c("div", { class: { "mt-4": !_vm.isHalf } }, [
              _c(
                "div",
                { staticClass: "d-flex align-items-center" },
                _vm._l(_vm.stateOptions, function(item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "mt-1 mr-4" },
                    [
                      _c("check-box", {
                        attrs: {
                          disabled: _vm.isReadOnly,
                          text: item.name,
                          value: _vm.checkeds.includes(item.id)
                        },
                        on: {
                          input: function($event) {
                            return _vm.onCheck($event, item)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _c(
                "div",
                { staticClass: "d-block mt-2" },
                [
                  _c("validation-provider", {
                    ref: `${_vm.value.area.id}-checkeds`,
                    attrs: {
                      name: `${_vm.value.area.id}-checkeds`,
                      rules: _vm.checkeds?.length ? "" : "required"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            errors[0]
                              ? _c("error", {
                                  attrs: {
                                    message:
                                      "Debe seleccionar al menos una opción.",
                                    variant: "no-border"
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ])
          ]
        )
      ]),
      _c("div", { staticClass: "border-top my-4" }),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("validation-provider", {
            staticClass: "w-100",
            attrs: {
              name: `area-${_vm.value.area.id}-answer`,
              rules: "required"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.answer,
                          expression: "model.answer"
                        }
                      ],
                      attrs: { type: "hidden" },
                      domProps: { value: _vm.model.answer },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.model, "answer", $event.target.value)
                        }
                      }
                    }),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      _vm._l(_vm.answerOptions, function(option) {
                        return _c(
                          "button",
                          {
                            key: `option-answer-${option.id}`,
                            staticClass: "ged-answer-btn",
                            class: { active: _vm.isAnswerSelected(option) },
                            attrs: { disabled: _vm.isReadOnly, type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.onAnswer(option)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "far d-block mb-1",
                              class: [
                                _vm.isAnswerSelected(option)
                                  ? "fa-check-circle"
                                  : "fa-circle"
                              ]
                            }),
                            _vm._v(" " + _vm._s(option.name) + " ")
                          ]
                        )
                      }),
                      0
                    ),
                    errors[0]
                      ? _c("error", {
                          attrs: {
                            message: "Debe seleccionar al menos una opción.",
                            variant: "no-border mt-2"
                          }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }